import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

import {
  getCart,
  updateCartItemQuantity,
  removeFromCart,
  getCartTotal,
} from "../../utils/cart";

import type { CartItem } from "../../utils/cart";
import { addToCart, isInCart, getCartQuantity } from "../../utils/cart";
import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
  Authorization_Token,
  staticToken,
} from "../../Services/Urls";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";
import AuthModal from "../../components/feature/AuthModal";

export default function CartPage() {
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const { logindata, setlogindata, userData, setuserData } = context;

  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [promoCode, setPromoCode] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [quantities, setQuantities] = useState<{ [key: number]: number }>({});

  const [Categories, setCategories] = useState<any[]>([]);
  const [items, setItems] = useState<any[]>([]);
  const [ItemMasterData, setItemMasterData] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    getItems();
    window.scrollTo(0, 0);
  }, []);

  const getdataformItemMaster = (ids: any) => {
    getRecords(1478, 100, -1, `{ItemID: { $in: [${ids}] }}`, 1, "", (data) => {
      // console.log("user details response", response);

      if (data != null) {
        if (data?.hasErrors === false) {
          setItemMasterData(data?.response?.records || []);

          setLoading(false);
        } else {
          setLoading(false);
          console.log("Error in fetching categories", data);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const getItems = () => {
    const cart = localStorage.getItem("cart-UniversalDairy");
    let ids = null;

    if (cart) {
      const parsedCart = JSON.parse(cart);
      const qtyMap: { [key: number]: number } = {};

      parsedCart.forEach((item: any) => {
        qtyMap[item.ItemID] = item.Qty;
      });

      setQuantities(qtyMap);

      const itemIdsInCart = parsedCart.map((item: any) => item.ItemID);
      ids = itemIdsInCart.join(",");
    }

    const PriceID = localStorage.getItem("UserData-UniversalDairy")
      ? JSON.parse(localStorage.getItem("UserData-UniversalDairy") || "{}")
          .ContractID
      : 1;
    let Url = `${BaseUrl}/api/Dynamic/GetRecords?tabErpID=${3323}&tabName=Sub%20Category`;

    const itemBody = {
      pgSize: 1000,
      viewFormat: "columnname",
      filterButtons: "",
      index: 1,
      toEmailID: "admin@dialerp.com",
      tabErpID: 3323,
      useAtlusSearch: false,
      RoleID: 0,
      LedgerID: LoggedInUserID ? LoggedInUserID : 1002, // replace with your actual variable
      order: -1,
      orderBy: "",
      processID: 1,

      filters: `{ItemID: { $in: [${ids}] },'PriceContractID':${PriceID || 1},'ValidFrom': { $lte: ISODate('${new Date().toISOString()}')}}`,
    };

    callApi(
      Url,
      itemBody,
      Authorization_Token ? Authorization_Token : staticToken,
      (data: any) => {
        if (data != null) {
          if (data?.hasErrors === false) {
            setItems(data?.response?.records || []);

            if (data?.response?.records?.length > 0) {
              getdataformItemMaster(
                data?.response?.records
                  ?.map((item: any) => item.ItemID)
                  .join(",") ?? "",
              );
            }

            setLoading(false);
          } else {
            setLoading(false);
            console.log("Error in fetching categories", data);
          }
        } else {
          setLoading(false);
        }
      },
      (error: any) => {
        setLoading(false);
      },
    );
  };

  const calculateSubtotal = () => {
    const cart = getCart();
    let subtotal = 0;

    cart.forEach((cartItem: any) => {
      const priceItem = items?.find((p) => p.ItemID === cartItem.ItemID);

      const item = ItemMasterData?.find((i) => i.ItemID === cartItem.ItemID);

      const caseRate = parseFloat(priceItem?.DistributorCaseRate || "0");
      const units = parseFloat(priceItem?.ItemInCase || "0");

      let unitPrice = 0;

      if (caseRate > 0 && units > 0) {
        unitPrice = caseRate / units;
      } else {
        unitPrice = parseFloat(item?.MRP || "0");
      }

      subtotal += unitPrice * cartItem.Qty;
    });

    return subtotal;
  };

  const handleQuantityChange = (productId: number, delta: number) => {
    setQuantities((prev) => {
      const currentQty = prev[productId] || 1;
      if (currentQty === 1 && delta === -1) {
        handleRemove(productId);
      }
      const newQty = Math.max(0, Math.min(10, currentQty + delta));

      updateCartItemQuantity(productId, newQty);

      if (newQty === 0) {
        const updated = { ...prev };
        delete updated[productId];
        return updated;
      }

      return {
        ...prev,
        [productId]: newQty,
      };
    });
  };

  const subtotal = getCartTotal();
  const shipping = subtotal > 0 ? (subtotal > 1000 ? 0 : 50) : 0;
  const total = subtotal + shipping;

  const handleProceedToCheckout = () => {
    if(logindata && Object.keys(logindata).length > 0){

  navigate("/checkout");
    }else{
      setShowAuthModal(true);
    }
  
    // const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    // if (isLoggedIn) {
    //   navigate('/checkout');
    // } else {
    //   setShowAuthModal(true);
    // }
  };

  const handleLoginSuccess = () => {
    setShowAuthModal(false);
    navigate("/checkout");
  };

  const handleRemove = (itemID: number) => {
    removeFromCart(itemID);

    setItems(items?.filter((item: any) => item.ItemID !== itemID));
  };

  return (
    <>
        <AuthModal 
           isOpen={showAuthModal} 
           onClose={() => setShowAuthModal(false)}
           onLoginSuccess={handleLoginSuccess}
         />
      <div className="min-h-screen bg-white">
        {/* Fixed Header */}
        <div
          className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? "bg-white shadow-md" : "bg-white"}`}
        >
          <Navbar />
        </div>

        {/* Auth Modal */}
        <AuthModal
          isOpen={showAuthModal}
          onClose={() => setShowAuthModal(false)}
          onLoginSuccess={handleLoginSuccess}
        />

        {/* Banner Area */}
        <div className="pt-20">
          <div className="relative h-48 bg-gradient-to-r from-amber-100 via-orange-50 to-amber-100 overflow-hidden">
            <section className="relative pt-20 pb-20 bg-gradient-to-br from-[#1A2B4A] to-[#00B8A9]">
              <div className="max-w-7xl mx-auto px-6">
                <h1 className="text-6xl md:text-5xl font-bold text-white mb-6 leading-tight">
                  Shopping Cart
                </h1>
              </div>
            </section>
            {/* Decorative Elements */}
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-amber-200/30 rounded-full blur-3xl"></div>
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-orange-200/30 rounded-full blur-3xl"></div>
          </div>
        </div>

        {/* Cart Content */}
        <div className="py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-gray-600 mb-8">
              {items.length} items in your cart
            </p>

            {items.length === 0 ? (
              <div className="text-center py-20">
                <i className="ri-shopping-cart-line text-8xl text-gray-300 mb-6"></i>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Your cart is empty
                </h2>
                <p className="text-gray-600 mb-8">
                  Add some delicious dairy products to get started!
                </p>
                <Link
                  to="/products"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
                >
                  Continue Shopping
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ) : (
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2">
                  <div className="space-y-4">
                    {items?.map((product) => (
                      <div
                        key={product.ItemID}
                        className="bg-white border border-gray-200 rounded-xl p-6 flex gap-6"
                      >
                        <Link
                          to={`/product/${product.ItemID}`}
                          className="flex-shrink-0"
                        >
                          <div className="w-32 h-32 bg-gray-100 rounded-lg overflow-hidden">
                            <img
                              src={
                                ItemMasterData?.find(
                                  (item) => item.ItemID === product.ItemID,
                                )?.ItemPic ||
                                "https://dialerpstorageac.blob.core.windows.net/10417/36/2596/2.png"
                              }
                              alt={product.Item}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        </Link>

                        <div className="flex-1">
                          <Link
                            to={`/product/${product.ItemID}/${product.PriceContractID}`}
                          >
                            <h3 className="text-xl font-bold text-gray-900 mb-2 hover:text-amber-600 transition-colors">
                              {product.Item}
                            </h3>
                          </Link>
                          {/* <p className="text-gray-600 mb-4">
                          {
                            ItemMasterData?.find(
                              (item) => item.ItemID === product.ItemID,
                            )?.Size
                          }
                        </p> */}

                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <button
                                onClick={() =>
                                  handleQuantityChange(product.ItemID, -1)
                                }
                                className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
                              >
                                <i className="ri-subtract-line"></i>
                              </button>
                              <span className="text-lg font-semibold text-gray-900 w-8 text-center">
                                {" "}
                                {getCartQuantity(
                                  product.ItemID,
                                  product.PriceContractID,
                                )}
                              </span>
                              <button
                                onClick={() =>
                                  handleQuantityChange(product.ItemID, 1)
                                }
                                className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
                              >
                                <i className="ri-add-line"></i>
                              </button>
                            </div>

                            <div className="text-right">
                              {(() => {
                                const priceItem = items?.find(
                                  (p) => p.ItemID === product.ItemID,
                                );

                                const item = ItemMasterData?.find(
                                  (i) => i.ItemID === product.ItemID,
                                );

                                const caseRate = parseFloat(
                                  priceItem?.DistributorCaseRate || "0",
                                );
                                const units = parseFloat(
                                  priceItem?.ItemInCase || "0",
                                );

                                let unitPrice = 0;
                                let unitMrp = 0;

                                if (caseRate > 0 && units > 0) {
                                  unitPrice = caseRate / units; // 304 / 40 = 7.6
                                  unitMrp =
                                    parseFloat(priceItem?.CaseMRP || "0") /
                                    units; // 400 / 40 = 10
                                } else {
                                  unitPrice = parseFloat(item?.MRP || "0");
                                  unitMrp = parseFloat(item?.MRP || "0");
                                }

                                return (
                                  <p className="text-1xl font-bold text-gray-900">
                                    {" "}
                                    ₹{unitPrice.toFixed(2)}
                                  </p>
                                );
                              })()}

                              <button
                                onClick={() => handleRemove(product?.ItemID)}
                                className="text-red-600 hover:text-red-700 text-sm mt-2 cursor-pointer"
                              >
                                <i className="ri-delete-bin-line"></i> Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="lg:col-span-1">
                  <div className="bg-gray-50 rounded-xl p-6 sticky top-28">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">
                      Order Summary
                    </h2>

                    <div className="space-y-4 mb-6">
                      <div className="flex justify-between text-gray-600">
                        <span>Subtotal</span>
                        <span className="font-semibold">
                          {" "}
                          ₹{calculateSubtotal().toFixed(2)}
                        </span>
                      </div>
                      <div className="flex justify-between text-gray-600">
                        <span>Shipping</span>
                        <span className="font-semibold">{"FREE"}</span>
                      </div>
                      {/* {subtotal > 0 && subtotal <= 1000 && (
                      <p className="text-sm text-green-600">
                        Add ₹{1000 - subtotal} more for free shipping!
                      </p>
                    )} */}
                    </div>

                    <div className="border-t border-gray-300 pt-4 mb-6">
                      <div className="flex justify-between text-xl font-bold text-gray-900">
                        <span>Total</span>
                        <span>₹{calculateSubtotal().toFixed(2)}</span>
                      </div>
                    </div>

                    <div className="mb-6">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Promo Code
                      </label>
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={promoCode}
                          onChange={(e) => setPromoCode(e.target.value)}
                          placeholder="Enter code"
                          className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm"
                        />
                        <button className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-semibold whitespace-nowrap cursor-pointer">
                          Apply
                        </button>
                      </div>
                    </div>

                    <button
                      onClick={handleProceedToCheckout}
                      className="block w-full py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors text-center mb-4 whitespace-nowrap cursor-pointer"
                    >
                      Proceed to Checkout
                    </button>

                    <Link
                      to="/products"
                      className="block w-full py-4 bg-white border-2 border-gray-300 text-gray-900 rounded-lg font-semibold hover:bg-gray-50 transition-colors text-center whitespace-nowrap"
                    >
                      Continue Shopping
                    </Link>

                    <div className="mt-6 flex items-center justify-center gap-4 text-sm text-gray-600">
                      <i className="ri-shield-check-line text-green-600 text-xl"></i>
                      <span>Secure Checkout</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
